import styled from "styled-components";
import {UserMenuHeaderDefaultBox} from "./user-menu-header.default.box";

export const UserMenuHeaderMrGreenBox = styled(UserMenuHeaderDefaultBox)`
  padding: 1.3rem 0 1.3rem 0;
`